import { Button } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useOnSaveAndNext } from '../hooks/useOnSaveAndNext';
import { CampaignEditorTab, useActiveTab } from '../hooks/useActiveTab';
import { useCampaignEditorContext } from '../state/hooks/useCampaignEditorContext';

const Footer = styled.div`
  background-color: ${({ theme }) => theme.vars.newColor.white};
  padding: 8px 40px;
  width: 100%;
  display: flex;
  justify-content: end;
  border-top: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
`;

export const CampaignFooterArea = () => {
  const { t } = useTranslation('campaigns');
  const { onSaveAndNext } = useOnSaveAndNext();
  const { state } = useCampaignEditorContext();
  const activeTab = useActiveTab();
  const isScheduling = activeTab === CampaignEditorTab.Scheduling;

  const buttonText = isScheduling
    ? t('bulkRetargetingCampaigns.editor.scheduling.save')
    : t('bulkRetargetingCampaigns.editor.saveAndNext');
  const buttonAriaLabel = isScheduling
    ? t('bulkRetargetingCampaigns.editor.scheduling.saveAriaLabel')
    : t('bulkRetargetingCampaigns.editor.saveAndNextAriaLabel');

  return (
    <Footer>
      <Button variation="secondary" onClick={onSaveAndNext} ariaLabel={buttonAriaLabel} disabled={state.readOnly}>
        {buttonText}
      </Button>
    </Footer>
  );
};
